module.exports = __webpack_public_path__ + "static/media/Binacle_gaussian2.2622997a.png";